import Text from 'components/Formik/Text';

const LicenseNumber = ({ initialValues, formik, label }) => {
	initialValues.nPI = '';
	return (
		<>
			{formik.values.Country === 'United States' && <Text label={label} name='nPI' type='text' />}
		</>
	);
};

export default LicenseNumber;
